import { setOrganizationUsers } from "../actions/auth";
import { appStore, persistor } from "../modules/store";
import { organizationStoreName } from "../reducers/organization";
import { LocalStorageKeys } from "../types/enums";
import { apiService } from "./rtkApi/apiService";
import { localStorageService } from "./local-storage-service";

/**
 * Clears persisted Redux (account, organization, lookups), RTK Query cache,
 * auth org-user list, and related localStorage. Call before Auth0 logout.
 */
export async function clearClientSessionOnLogout() {
  localStorageService.removeLocalStorage(organizationStoreName);

  localStorage.removeItem(LocalStorageKeys.AccessToken);
  localStorage.removeItem(LocalStorageKeys.OrganizationUserId);
  localStorage.removeItem(LocalStorageKeys.UserRoles);
  localStorage.removeItem(LocalStorageKeys.NameId);

  appStore.dispatch(setOrganizationUsers([]));
  appStore.dispatch(apiService.util.resetApiState());

  try {
    await persistor.purge();
  } catch (e) {
    console.error("persistor.purge failed", e);
  }
}
